module.exports = __webpack_public_path__ + "img/Banner-Mobile.63295278.png";